import React from 'react';
import ReactDOM from 'react-dom/client';
import {ServiceFactory} from '../../services/service-factory';
import {ContainerComponent} from '../container/container.component';
import {observer} from 'mobx-react';
import {ModalDialogsContainerComponent} from '../modal-dialog/modal-dialogs-container.component';
import {OrbitComponentsRenderedInsideSdkContainer} from '../sdk/orbit-components-rendered-inside-sdk-container';
import {OrbitContextProvider} from '../../orbit-context';
import {StyleSheetManager, ThemeProvider} from 'styled-components';
import RtlPlugin from 'stylis-plugin-rtl';
import { RouterOutletComponent } from '../router-outlet/router-outlet.component';
import { MainScreenComponent } from '../../basic-components/main-screen/main-screen.component';
import { PlayerBurnoutLayerComponent } from '../burnout/player-burnout-layer.component';
import {ToolTipContainerComponent} from "../tooltip/tooltip-container.component";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {CurrentGameContainerComponent} from "../current-game-container/current-game-container.component"; // Pagination module
import {ToasterComponent} from '../toaster/toaster.component';

export interface AppComponentProps {
  services: ServiceFactory,
}

export const AppComponent = observer(class AppComponent extends React.Component<AppComponentProps, {}> {

  componentDidMount() {
    this.props.services.splash.removeSplash();
    let splashTime = this.props.services.splash.splashTime;
    this.props.services.analytics.sendTechnicalEvent('splash-time-splash_main',
                                                      this.props.services.location.currentUri.pathName.toString(),
                                                      splashTime);
    this.props.services.logger.info(`Splash time: ${splashTime} seconds`);
  }


  render() {
    return (
        <OrbitContextProvider value={{services: this.props.services}}>
          <StyleSheetManager disableCSSOMInjection={true} stylisPlugins={this.props.services.language.isRTLLanguage ? [RtlPlugin] : []}>
            <ThemeProvider theme={this.props.services.theme.currentTheme}>
              {this.props.services.theme.renderGlobalStyles()}
              { this.props.services.routing.currentRoute?.data?.standalone ?
                <MainScreenComponent>
                  <RouterOutletComponent />
                </MainScreenComponent> :
                <ContainerComponent/>
              }
              <CurrentGameContainerComponent/>
              <ModalDialogsContainerComponent/>
              <ToolTipContainerComponent key={'REGULAR_TOOLTIPS'} toolTipsProvider={() => this.props.services.regularTooltips}/>
              <ToolTipContainerComponent key={'ON_BOARDING_TOOLTIPS'} toolTipsProvider={() => this.props.services.onBoardingTooltips}/>
              <PlayerBurnoutLayerComponent />
              <ToasterComponent />
              <OrbitComponentsRenderedInsideSdkContainer/>
            </ThemeProvider>
          </StyleSheetManager>
        </OrbitContextProvider>
    )
  }
});


export function renderApp(services: ServiceFactory): void {
  const root = ReactDOM.createRoot(
      document.getElementById('orbit-container') as HTMLElement
  );

  root.render(
        <AppComponent services={services} />
  );
}
